import { useMutation } from '@apollo/client';
import { useGeneralSoContext } from 'src/common/context';
import { recordPaymentError } from './useFinishPayment.mutation';
import type { RecordPaymentErrorMutation, RecordPaymentErrorMutationVariables } from '../types/types';

export interface SetPaymentErrorsInput {
  paymentErrors: string[];
}

/**
 * Hook to record payment errors to the backend.
 * Call with error codes from the checkout failure URL (e.g. from ErrorCodes query param).
 */
export function useSetPaymentErrors(): [(input: SetPaymentErrorsInput) => Promise<void>] {
  const { offerId } = useGeneralSoContext();
  const [recordError] = useMutation<RecordPaymentErrorMutation, RecordPaymentErrorMutationVariables>(recordPaymentError);

  const setPaymentErrors = async (input: SetPaymentErrorsInput) => {
    if (!offerId || !input.paymentErrors?.length) return;
    for (const errorCode of input.paymentErrors) {
      await recordError({
        variables: {
          offerId,
          errorCode: errorCode.trim(),
          errorMessage: errorCode.trim(),
        },
      }).catch(() => {
        // Ignore per-error failures; at least one may succeed
      });
    }
  };

  return [setPaymentErrors];
}
